import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { CARBON_INTENSITY_PAGE } from './carbon_intensity.js';

mountLearnPage(CARBON_INTENSITY_PAGE);
